module.exports = __webpack_public_path__ + "static/media/cl.a92b49b8.svg";